import React from 'react';
import Draggable from 'react-draggable';
import {
    changeStrokeSize,
    changeShapeOpacity,
    updateCurrentSlideThumbnail,
    updateShapeRotation
} from '../../actions/CurrentSlideActions';
import properties from '../../constants/Properties';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../utils/PlatformDetection';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import locales from '../../locales/LocalesManager';

export const CustomSlider = React.createClass({
    getInitialState () {
        const step = (this.props.properties.end - this.props.properties.start) / this.props.properties.step;
        const realStep = (this.props.properties.width - this.props.properties.thumbSize) / step;

        return {
            step: realStep,
            isThumbOver: false
        };
    },
    componentDidMount() {
        if (platformDetection.isTouchableDevice()) {
            this.refs.track.addEventListener('touchend', this.onTrackMouseDown);

            if (platformDetection.isChromeBook())
                this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
        } else
            this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
    },
    updateThumbnail() {
        this.props.properties.dispatch(updateCurrentSlideThumbnail(true));
    },
    getCurrentStep (position) {
        const floatValue = position / this.state.step;
        const integerPart = parseInt(floatValue, 10);

        var newPosition;

        if ((floatValue - integerPart) > 0.5)
            newPosition = integerPart  + 1;
        else
            newPosition = integerPart;

        return newPosition;
    },
    getSliderPosition (position) {
        const newStep = this.getCurrentStep(position);
        return newStep * this.state.step;
    },
    getSliderValue (position) {
        const newStep = this.getCurrentStep(position);
        return this.props.properties.start + newStep * this.props.properties.step;
    },
    onTrackMouseDown (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var newPosition = mouseUtils.getLocalPosition(e, this.refs.track, false) - this.props.properties.thumbSize / 2;

        if (isNaN(newPosition))
            return;

        if (newPosition < 0)
            newPosition = 0;

        if (newPosition > (this.props.properties.width - this.props.properties.thumbSize))
            newPosition = this.props.properties.width - this.props.properties.thumbSize;

        const sliderPosition = this.getSliderPosition(newPosition);

        this.refs.thumb.style.left = sliderPosition + 'px';

        this.changeProperties(this.getSliderValue(newPosition));
        this.updateThumbnail();
    },
    onMouseDown () {
        var leftString = this.refs.thumb.style.left;
        var left = Number(leftString.substring(0, leftString.length - 2));

        this.setState({
            startPosition: left,
            currentPosition: left
        });
    },
    checkPosition(deltaX) {
        var newPosition = (this.state.startPosition +  deltaX);
        const leftValue = 0;
        const rightValue = this.props.properties.width - this.props.properties.thumbSize;

        if (newPosition - leftValue < 0.001)
            newPosition = leftValue;
        else if (newPosition > rightValue)
            newPosition = rightValue;

        const sliderPosition = this.getSliderPosition(newPosition);

        if(sliderPosition != this.state.currentPosition) {
            this.refs.thumb.style.left = sliderPosition + 'px';

            this.setState({
                currentPosition: sliderPosition
            });

            this.changeProperties(this.getSliderValue(this.state.currentPosition));
        }
    },
    onThumbMouseIn () {
        this.setState({
            isThumbOver: true
        });
    },
    onThumbMouseOut () {
        this.setState({
            isThumbOver: false
        });
    },
    onKeyDown(e) {
        var delta = this.state.step;

        if (delta < 0)
            delta = (-1) * delta;

        if (e.keyCode == 37) { // Left Key
            this.onMouseDown();
            setTimeout(function() {
                this.onMouseMove(undefined, undefined, - delta);
            }.bind(this), 10);
        } else
        if (e.keyCode == 39) { // Right Key
            this.onMouseDown();
            setTimeout(function() {
                this.onMouseMove(undefined, undefined, delta);
            }.bind(this), 10);
        }
    },
    onMouseMove (e, coreEvent, movement) {
        if (movement)
            this.checkPosition(movement);
        else
            this.checkPosition(coreEvent.lastX);
    },
    onMouseUp (e, coreEvent) {
        this.checkPosition(coreEvent.lastX);

        this.updateThumbnail();
    },
    getTarget() {
        return this.props.properties.target;
    },
    changeProperties (newValue) {
        if (newValue == undefined)
            return;

        var shapeModel = this.getTarget();

        if (this.props.properties.type == 'change_opacity') {
            this.props.properties.dispatch(changeShapeOpacity(shapeModel, newValue));
        }
        else if (this.props.properties.type == 'change_stroke') {
            if (this.props.properties.isTextEditorTool)
                this.props.executeCommand('changeStrokeSize', newValue);
            else
                this.props.properties.dispatch(changeStrokeSize(shapeModel, newValue));
        } else
        if (this.props.properties.type == 'change_rotation') {
            this.props.properties.dispatch(updateShapeRotation(shapeModel.uuid, newValue));
        }

        audioEditorUtils.addActionToHistory();
        saveManager.isContentChanged(true);
    },
    getThumbInitialPosition () {
        const target = this.getTarget();
        var value;

        if (target) {
            if (this.props.properties.type == 'change_stroke') {
                if (target.strokeWidth >= 0 && target.strokeOpacity == 1) {
                    value = ((target.strokeWidth - this.props.properties.start) / this.props.properties.step) * this.state.step;
                }
                else
                    value = 0;
            } else if (this.props.properties.type == 'change_opacity') {
                if (target.opacity == 1)
                    value = 0;
                else {
                    if (target.opacity >= 0)
                        value = ((target.opacity - this.props.properties.start) / this.props.properties.step) * this.state.step;
                    else
                        value = 0;
                }
            } else if (this.props.properties.type == 'change_rotation') {
                if (target.rotation >= 0)
                    value = ((target.rotation - this.props.properties.start) / this.props.properties.step) * this.state.step;
                else
                    value = 0;
            }
        } else
            value = 0;

        if (value < 0)
            value = 0;

        return value;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isThumbOver != nextState.isThumbOver || this.state.currentPosition != nextState.currentPosition || this.props.properties != newProps.properties)
            return true;
        else
            return false;
    },
    render() {
        const localProps = this.props.properties;

        const wrapperStyle = {
            position: 'absolute',
            left: localProps.leftPosition,
            top: localProps.topPosition,
            width: localProps.width,
            height: localProps.height,
            overflowX: 'hidden',
            overflowY: 'hidden',
            cursor: 'default'
        };

        const backgroundStyle = {
            position: 'absolute',
            width: localProps.width,
            height: localProps.height,
            cursor: 'default'
        };

        const thumbBorderSize = 2;
        var thumbBorderColor = 'green';

        if (this.state.isThumbOver == true || this.state.isThumbActive == true)
            thumbBorderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

        const thumbStyle = {
            position: 'absolute',
            width: localProps.thumbSize - 2 * thumbBorderSize,
            height: localProps.thumbSize - 2 * thumbBorderSize,
            left: this.getThumbInitialPosition(),
            top: localProps.height / 2 - localProps.thumbSize / 2,
            background: 'white',
            borderStyle: 'solid',
            borderColor: thumbBorderColor,
            borderWidth: 2,
            borderRadius: 50,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            cursor: 'pointer'
        };

        return (
            <div style={wrapperStyle}>
                <img alt='' aria-hidden='true' ref='track' style={backgroundStyle} src={localProps.backgroundHref}/>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                    <button id={this.props.id} aria-label={locales.getCaption('Opacity', 'advancedMenu')} className='sliderThumb' ref='thumb' style={thumbStyle} onKeyDown={this.onKeyDown} onMouseOver={this.onThumbMouseIn} onMouseOut={this.onThumbMouseOut}/>
                </Draggable>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/CustomSlider.js
 **/